export default "__VITE_ASSET__8tS6XpMT__";